/* POWCHEE — Practitioners Program v5.
   Floating CTA + in-page nav, plus the v4 application/question form behaviour
   (join-or-ask chooser, social-channel validation, submission summary). */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.p5Ready) return;
    root.dataset.p5Ready = '1';

    var fab  = root.querySelector('[data-p5="fab"]');
    var join = root.querySelector('[data-p5="join"]');

    /* the floating CTA stays visible the whole way down */
    if (fab) fab.classList.remove('is-off');

    /* ── gluten COA lightbox ── */
    var lb = root.querySelector('[data-p5="coa-lb"]');
    if (lb) {
      var frame = lb.querySelector('[data-coa-frame]');
      var ttl = lb.querySelector('[data-coa-title]');
      var dl = lb.querySelector('[data-coa-dl]');
      var lastBtn = null;
      /* PDFs are drawn with PDF.js: browsers refuse to show a PDF inside an
         iframe on most phones, in sandboxed previews, and when the CDN sends
         it as a download. The native iframe stays as the fallback. */
      var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/';
      var pages = document.createElement('div');
      pages.className = 'coa-lb__pg';
      frame.parentNode.insertBefore(pages, frame);
      frame.hidden = true;
      var renderTok = 0, pdfjsP = null;
      function loadPdfjs() {
        if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
        if (pdfjsP) return pdfjsP;
        pdfjsP = new Promise(function (res, rej) {
          var s = document.createElement('script');
          s.src = PDFJS + 'pdf.min.js';
          s.onload = function () {
            if (!window.pdfjsLib) return rej(new Error('pdf.js missing'));
            window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS + 'pdf.worker.min.js';
            res(window.pdfjsLib);
          };
          s.onerror = function () { pdfjsP = null; rej(new Error('pdf.js failed to load')); };
          document.head.appendChild(s);
        });
        return pdfjsP;
      }
      function coaFallback(href) {
        pages.innerHTML = '';
        frame.hidden = false;
        frame.src = href + '#toolbar=0&navpanes=0&view=FitH';
        var n = document.createElement('p');
        n.className = 'coa-lb__msg';
        n.innerHTML = 'If the certificate doesn\u2019t appear, <a href="' + href + '" target="_blank" rel="noopener">open the PDF in a new tab</a>.';
        pages.appendChild(n);
        pages.classList.add('is-fb');
      }
      function renderCoa(href) {
        var tok = ++renderTok;
        frame.hidden = true;
        pages.classList.remove('is-fb');
        pages.innerHTML = '<p class="coa-lb__msg">Loading certificate\u2026</p>';
        pages.scrollTop = 0;
        loadPdfjs().then(function (lib) {
          return lib.getDocument(href).promise;
        }).then(function (pdf) {
          if (tok !== renderTok) return;
          pages.innerHTML = '';
          var w = Math.max(280, pages.clientWidth - 32);
          var dpr = Math.min(window.devicePixelRatio || 1, 2);
          var chain = Promise.resolve();
          for (var i = 1; i <= pdf.numPages; i++) {
            (function (n) {
              chain = chain.then(function () {
                if (tok !== renderTok) return;
                return pdf.getPage(n).then(function (page) {
                  var v1 = page.getViewport({ scale: 1 });
                  var vp = page.getViewport({ scale: (w / v1.width) * dpr });
                  var c = document.createElement('canvas');
                  c.width = Math.floor(vp.width);
                  c.height = Math.floor(vp.height);
                  c.style.width = w + 'px';
                  c.setAttribute('role', 'img');
                  c.setAttribute('aria-label', 'Page ' + n + ' of ' + pdf.numPages);
                  pages.appendChild(c);
                  return page.render({ canvasContext: c.getContext('2d'), viewport: vp }).promise;
                });
              });
            })(i);
          }
          return chain;
        }).catch(function () {
          if (tok === renderTok) coaFallback(href);
        });
      }
      function openCoa(btn) {
        var href = btn.getAttribute('data-coa');
        lastBtn = btn;
        ttl.textContent = btn.getAttribute('data-coa-name') || 'Certificate of analysis';
        dl.href = href;
        lb.hidden = false;
        renderCoa(href);
        document.documentElement.style.overflow = 'hidden';
        lb.querySelector('.coa-lb__x').focus();
      }
      function closeCoa() {
        lb.hidden = true;
        renderTok++;
        frame.src = 'about:blank';
        frame.hidden = true;
        pages.innerHTML = '';
        document.documentElement.style.overflow = '';
        if (lastBtn) lastBtn.focus();
      }
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-coa]');
        if (b) { e.preventDefault(); openCoa(b); return; }
        if (e.target.closest('[data-coa-close]')) closeCoa();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) closeCoa(); });
    }

    /* ── dig-deeper: one group and one panel open at a time, with a
       sticky close control so you never scroll back up to collapse ── */
    var more = root.querySelector('.more');
    if (more) {
      var grps = [].slice.call(more.querySelectorAll('details.grp'));
      var pnls = [].slice.call(more.querySelectorAll('details.pnl'));

      function topOf(el, pad) {
        return el.getBoundingClientRect().top + scrollY - (pad || 16);
      }
      function closeTo(d, host) {
        d.open = false;
        scrollTo({ top: topOf(host || d, 20), behavior: soft });
      }
      function addBar(d, label, host) {
        var body = d.querySelector(':scope > .grp__c, :scope > .pnl__b');
        if (!body || body.querySelector('.clx')) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'clx';
        b.innerHTML = '<s aria-hidden="true"></s>' + label;
        b.addEventListener('click', function () { closeTo(d, host); });
        body.appendChild(b);
      }

      grps.forEach(function (g) {
        addBar(g, 'Close this section', g);
        g.addEventListener('toggle', function () {
          if (!g.open) return;
          grps.forEach(function (o) { if (o !== g) o.open = false; });
        });
      });
      pnls.forEach(function (p) {
        var g = p.closest('details.grp');
        addBar(p, 'Close and pick another', p);
        p.addEventListener('toggle', function () {
          if (!p.open) return;
          pnls.forEach(function (o) { if (o !== p && o.closest('details.grp') === g) o.open = false; });
        });
      });
    }

    /* smooth in-page nav that respects reduced motion */
    var soft = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      var t = id && document.getElementById(id);
      if (!t) return;
      e.preventDefault();
      scrollTo({ top: t.getBoundingClientRect().top + scrollY - 24, behavior: soft });
    });

    /* open a dropdown when linked to directly */
    root.querySelectorAll('a[data-p5-open]').forEach(function (a) {
      a.addEventListener('click', function () {
        var d = document.getElementById(a.getAttribute('data-p5-open'));
        if (!d) return;
        d.open = true;
        var p = d.parentElement;
        while (p) { if (p.tagName === 'DETAILS') p.open = true; p = p.parentElement; }
      });
    });

    /* ── enrollment-option cards preselect the compensation radio ── */
    /* the cards and step 7 of the form are one choice: picking a card checks
       the radio; changing the radio in the form re-marks the card. If nothing
       was picked above, step 7 is required, so every application lands in a bucket. */
    var picks = [].slice.call(root.querySelectorAll('[data-p5-pick]'));
    var compR = [].slice.call(root.querySelectorAll('input[name="contact[Compensation]"]'));
    var compFrom = root.querySelector('[data-p5-from]');
    var pickedAbove = false;
    function paintComp() {
      var cur = compR.filter(function (r) { return r.checked; })[0];
      var v = cur ? cur.value : '';
      picks.forEach(function (el) {
        var on = el.getAttribute('data-p5-pick') === v;
        el.classList.toggle('is-on', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (compFrom) {
        var card = picks.filter(function (el) { return el.getAttribute('data-p5-pick') === v; })[0];
        var u = card && card.querySelector('u');
        compFrom.hidden = !(pickedAbove && v);
        if (pickedAbove && v) compFrom.textContent = 'You chose ' + (u ? u.textContent.trim().toLowerCase() + ' \u2014 ' : '') + v + ' in the enrollment options above. Change it here if you need to.';
      }
    }
    picks.forEach(function (el) {
      el.setAttribute('aria-pressed', 'false');
      el.addEventListener('click', function () {
        var v = el.getAttribute('data-p5-pick');
        var r = compR.filter(function (x) { return x.value === v; })[0];
        if (r) { pickedAbove = true; r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
    compR.forEach(function (r) { r.required = true; r.addEventListener('change', paintComp); });
    paintComp();

    /* ── join-or-ask chooser: buttons reveal one panel at a time ── */
    var togs = [].slice.call(root.querySelectorAll('[data-p3="tog"]'));
    var askJump = root.querySelector('[data-p3="askjump"]');
    if (askJump) {
      askJump.addEventListener('click', function (e) {
        var askBtn = root.querySelector('[data-p3="tog"][data-p3-role="ask"]');
        if (!askBtn) return;
        e.preventDefault();
        if (askBtn.getAttribute('aria-expanded') !== 'true') { askBtn.click(); return; }
        var pn = document.getElementById(askBtn.getAttribute('aria-controls'));
        if (pn) scrollTo({ top: pn.getBoundingClientRect().top + scrollY - 70, behavior: soft });
      });
    }
    if (togs.length) {
      var panelOf = function (b) { return document.getElementById(b.getAttribute('aria-controls')); };
      var show = function (btn, open, scroll) {
        togs.forEach(function (o) {
          var p = panelOf(o), me = (o === btn && open);
          if (p) p.hidden = !me;
          o.setAttribute('aria-expanded', me ? 'true' : 'false');
          o.classList.toggle('on', me);
        });
        if (open && scroll) {
          var p = panelOf(btn);
          if (p) scrollTo({ top: p.getBoundingClientRect().top + scrollY - 70, behavior: soft });
        }
      };
      /* Shopify marks BOTH contact forms posted_successfully? — the fragment names the one
         that actually posted, so suppress the other panel's stale success block. */
      var postedId = (location.hash || '').slice(1);
      [].slice.call(root.querySelectorAll('[data-p3-ok]')).forEach(function (ok) {
        if (postedId && ok.getAttribute('data-p3-ok') === postedId) return;
        ok.hidden = true;
        var stale = ok.parentNode;
        while (stale && stale !== root && String(stale.className).indexOf('pick2__p') < 0) stale = stale.parentNode;
        if (stale && stale !== root) stale.setAttribute('data-p3-stale', '1');
      });
      /* every join CTA lands on the first question of the form, cursor in the field — one click */
      var joinBtn = root.querySelector('[data-p3-role="join"]');
      var jPanel = joinBtn && panelOf(joinBtn);
      var fx = null;
      if (jPanel) {
        /* ── focus mode: the application opens full-screen; closing keeps every answer ── */
        var jForm = jPanel.querySelector('form.p3-appform');
        var KEY = 'p5-app-draft-v1';
        var bar = document.createElement('div');
        bar.className = 'fx__bar';
        bar.innerHTML = '<b class="fx__ttl">Practitioners Program application</b>' +
          '<span class="fx__note">Your answers save as you go</span>' +
          '<button type="button" class="fx__x" data-fx-close>Save &amp; exit <s aria-hidden="true">&times;</s></button>' +
          '<span class="fx__prog" aria-hidden="true"><i data-fx-prog></i></span>';
        jPanel.insertBefore(bar, jPanel.firstChild);
        var prog = bar.querySelector('[data-fx-prog]');
        var lastFocus = null, stepAt = 0, stepPos = 0, stepTot = 0, ctaLabel = joinBtn.innerHTML, restoring = true; /* no saves until the stored draft is read */
        var paintCta = function () {
          joinBtn.innerHTML = (stepAt > 0 && !jPanel.classList.contains('is-fx'))
            ? 'Resume your application &middot; step ' + (stepPos + 1) + ' of ' + stepTot + ' <s aria-hidden="true">&rarr;</s>'
            : ctaLabel;
        };
        var save = function () {
          if (restoring || !jForm) return;
          try {
            var d = { at: stepAt, v: {}, c: {} };
            [].forEach.call(jForm.elements, function (el) {
              var n = el.name;
              if (!n || el.type === 'hidden' || el.type === 'submit' || el.getAttribute('data-p3') === 'hp') return;
              if (el.type === 'radio') { if (el.checked) d.v[n] = el.value; return; }
              if (el.type === 'checkbox') { d.c[n + '|' + el.value] = el.checked; return; }
              if (el.value) d.v[n] = el.value;
            });
            localStorage.setItem(KEY, JSON.stringify(d));
          } catch (x) {}
        };
        var drop = function () { try { localStorage.removeItem(KEY); } catch (x) {} };
        var restore = function () {
          var okEl = jPanel.querySelector('.ok');
          if (okEl && !okEl.hidden) { drop(); restoring = false; return; }
          var d; try { d = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (x) {}
          if (!d || !jForm) { restoring = false; return; }
          var y = scrollY, els = [].slice.call(jForm.elements);
          var fire = function (el) { el.dispatchEvent(new Event('change', { bubbles: true })); };
          els.forEach(function (el) {
            var n = el.name;
            if (!n || el.type === 'hidden' || el.getAttribute('data-p3') === 'hp') return;
            if (el.type === 'radio') { if (d.v[n] === el.value && !el.checked) { el.checked = true; fire(el); } return; }
            if (el.type === 'checkbox') { var k = n + '|' + el.value; if (d.c && k in d.c && el.checked !== d.c[k]) { el.checked = d.c[k]; fire(el); } return; }
            if (el.tagName === 'SELECT' && d.v[n] != null) { el.value = d.v[n]; fire(el); }
          });
          els.forEach(function (el) {
            var n = el.name;
            if (!n || el.type === 'hidden' || el.type === 'radio' || el.type === 'checkbox' || el.tagName === 'SELECT' || el.getAttribute('data-p3') === 'hp') return;
            if (d.v[n] != null && !el.disabled) el.value = d.v[n];
          });
          if (document.activeElement && jForm.contains(document.activeElement)) document.activeElement.blur();
          scrollTo(0, y);
          var tfEl = jForm.querySelector('[data-p5-tf]');
          if (tfEl && d.at) tfEl.dispatchEvent(new CustomEvent('p5:goto', { detail: d.at }));
          restoring = false;
          paintCta();
        };
        fx = {
          open: function () {
            lastFocus = document.activeElement;
            show(joinBtn, true, false);
            jPanel.classList.add('is-fx');
            jPanel.setAttribute('role', 'dialog');
            jPanel.setAttribute('aria-modal', 'true');
            jPanel.setAttribute('aria-label', 'Practitioners Program application');
            document.documentElement.classList.add('p5-fx');
            jPanel.scrollTop = 0;
            paintCta();
            requestAnimationFrame(function () {
              var st = [].slice.call(jPanel.querySelectorAll('[data-tf-step]')).filter(function (s) { return !s.hidden; })[0] || jPanel;
              var f = st.querySelector('input:not([type=radio]):not([type=checkbox]):not([type=hidden]), select, textarea') || bar.querySelector('[data-fx-close]');
              if (f) f.focus({ preventScroll: true });
            });
          },
          close: function () {
            jPanel.classList.remove('is-fx');
            jPanel.removeAttribute('role');
            jPanel.removeAttribute('aria-modal');
            jPanel.removeAttribute('aria-label');
            document.documentElement.classList.remove('p5-fx');
            show(joinBtn, false, false);
            paintCta();
            var t = (lastFocus && document.contains(lastFocus) && lastFocus !== document.body) ? lastFocus : joinBtn;
            if (t && t.focus) t.focus({ preventScroll: true });
          }
        };
        bar.querySelector('[data-fx-close]').addEventListener('click', fx.close);
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && jPanel.classList.contains('is-fx')) { e.preventDefault(); fx.close(); }
        });
        jPanel.addEventListener('keydown', function (e) {
          if (e.key !== 'Tab' || !jPanel.classList.contains('is-fx')) return;
          var f = [].slice.call(jPanel.querySelectorAll('a[href],button,input,select,textarea')).filter(function (el) {
            return !el.disabled && el.tabIndex !== -1 && el.type !== 'hidden' && el.getClientRects().length && !el.closest('[hidden]');
          });
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        });
        jPanel.addEventListener('p5:step', function (e) {
          stepAt = e.detail.at; stepPos = e.detail.pos != null ? e.detail.pos : e.detail.at; stepTot = e.detail.total;
          if (prog) prog.style.width = (stepPos / stepTot * 100).toFixed(1) + '%';
          if (jForm) jForm.setAttribute('data-at', String(stepAt));
          save();
        });
        if (jForm) {
          jForm.addEventListener('input', save);
          jForm.addEventListener('change', save);
          jForm.addEventListener('submit', function (e) { setTimeout(function () { if (!e.defaultPrevented) drop(); }, 0); });
        }
        setTimeout(restore, 0);
      }
      var goForm = function () {
        if (fx) { fx.open(); return; }
        if (!joinBtn) return;
        show(joinBtn, true, true);
      };
      togs.forEach(function (b) {
        var p = panelOf(b);
        if (p) p.hidden = true;
        b.addEventListener('click', function () {
          var pn = panelOf(b);
          if (pn && pn.getAttribute('data-p3-stale')) { location.href = location.pathname + '#p5join'; location.reload(); return; }
          if (b.getAttribute('data-p3-role') === 'join') { goForm(); return; }
          show(b, b.getAttribute('aria-expanded') !== 'true', true);
        });
      });
      /* a submitted or errored form must come back open */
      var reopen = togs.filter(function (b) {
        var p = panelOf(b);
        if (!p) return false;
        var okEl = p.querySelector('.ok');
        if (okEl && !okEl.hidden) return true;
        return [].slice.call(p.querySelectorAll('[role="alert"]')).some(function (a) { return !a.hidden; });
      })[0];
      if (reopen) { if (reopen === joinBtn && fx) fx.open(); else show(reopen, true, false); }
      /* every CTA that points at the program opens the application */
      if (joinBtn) {
        [].slice.call(root.querySelectorAll('a[href*="p5join"]')).forEach(function (a) {
          a.addEventListener('click', function (e) { e.preventDefault(); goForm(); });
        });
      }
    }



    /* ── "five jobs" accordions: a close control at the bottom of each open item ── */
    [].slice.call(root.querySelectorAll('.acc details.ac')).forEach(function (d) {
      var body = d.querySelector(':scope > .ac__b');
      if (!body || body.querySelector('.clx')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'clx';
      btn.innerHTML = '<s aria-hidden="true"></s>Collapse';
      btn.addEventListener('click', function () {
        d.open = false;
        var y = d.getBoundingClientRect().top + scrollY - 90;
        if (y < scrollY) scrollTo({ top: y, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
      body.appendChild(btn);
    });
    /* ── product cards flip to their Nutrition Facts panel, independently ── */
    [].slice.call(root.querySelectorAll('[data-p5-flip]')).forEach(function (card) {
      var front = card.querySelector('.ocf__f'), back = card.querySelector('.ocf__b');
      function setFocusable(on) {
        [].slice.call(card.querySelectorAll('.ocf__f a,.ocf__f button')).forEach(function (el) {
          el.tabIndex = on ? -1 : 0;
        });
        [].slice.call(card.querySelectorAll('.ocf__b a,.ocf__b button')).forEach(function (el) {
          el.tabIndex = on ? 0 : -1;
        });
        if (front) front.setAttribute('aria-hidden', on ? 'true' : 'false');
        if (back) back.setAttribute('aria-hidden', on ? 'false' : 'true');
      }
      function flip(on) { card.classList.toggle('on', on); setFocusable(on); }
      setFocusable(false);
      if (front) {
        front.setAttribute('role', 'button');
        front.setAttribute('tabindex', '0');
        front.addEventListener('click', function (e) {
          if (e.target.closest('a')) return;
          flip(true);
        });
        front.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(true); }
        });
      }
      if (back) {
        back.addEventListener('click', function (e) {
          if (e.target.closest('a,.nft,.nft__dv')) return;
          flip(false);
        });
      }
    });

    /* ── Nutrition Facts back face: one %DV age toggle drives every card ── */
    var nfBoxes = [].slice.call(root.querySelectorAll('[data-nf-dv]'));
    nfBoxes.forEach(function (box) {
      [].slice.call(box.querySelectorAll('[data-nf-dv-set]')).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var v = btn.getAttribute('data-nf-dv-set');
          nfBoxes.forEach(function (b) {
            b.setAttribute('data-nf-dv', v);
            [].slice.call(b.querySelectorAll('[data-nf-dv-set]')).forEach(function (x) {
              x.setAttribute('aria-pressed', x.getAttribute('data-nf-dv-set') === v ? 'true' : 'false');
            });
          });
        });
      });
    });
    /* ── patient volume: "Other" reveals a short text field ── */
    var vol = root.querySelector('[data-p5-vol]');
    if (vol) {
      var volO = vol.querySelector('[data-p5-vol-other]');
      vol.addEventListener('change', function () {
        var v = (vol.querySelector('input[type=radio]:checked') || {}).value;
        var on = v === 'Other';
        volO.hidden = !on; volO.required = on;
        if (on) volO.focus(); else volO.value = '';
      });
    }
    /* ── digital presence: one handle field per channel picked ── */
    var hs = root.querySelector('[data-p5-hs]');
    if (hs) {
      var hsBox = hs.parentElement;
      function hsPaint() {
        var picked = {};
        [].forEach.call(hsBox.querySelectorAll('input[type=checkbox][data-q]'), function (c) { picked[c.getAttribute('data-q')] = c.checked; });
        [].forEach.call(hs.querySelectorAll('[data-hs-for]'), function (f) {
          var on = !!picked[f.getAttribute('data-hs-for')], inp = f.querySelector('input');
          f.hidden = !on; inp.required = on;
          if (!on) inp.value = '';
        });
      }
      hsBox.addEventListener('change', function (e) {
        if (e.target.type !== 'checkbox') return;
        hsPaint();
        if (e.target.checked) { var f = hs.querySelector('[data-hs-for="' + e.target.getAttribute('data-q') + '"] input'); if (f && innerWidth > 760) f.focus({ preventScroll: true }); }
      });
      hsPaint();
    }
    /* ── license question: reveal the matching follow-up ── */
    var licBox = root.querySelector('[data-p5-lic]');
    if (licBox) {
      var yesB = root.querySelector('[data-p5-lic-yes]'), noB = root.querySelector('[data-p5-lic-no]');
      var licIn = yesB && yesB.querySelector('#p5-lic'), roleIn = noB && noB.querySelector('#p5-role');
      function licPaint() {
        var v = (licBox.querySelector('input:checked') || {}).value;
        if (yesB) yesB.hidden = v !== 'Yes';
        if (noB) noB.hidden = v !== 'No';
        if (licIn) licIn.required = v === 'Yes';
        if (roleIn) roleIn.required = v === 'No';
      }
      [].slice.call(licBox.querySelectorAll('input')).forEach(function (r) { r.addEventListener('change', licPaint); });
      licPaint();
    }
    /* ── application form: social channels + submission summary ── */
    var form = root.querySelector('form.p3-appform');
    if (form) {
      var socBox  = form.querySelector('[data-p3="soc"]'),
          socNone = form.querySelector('[data-p3="soc-none"]'),
          socErr  = form.querySelector('[data-p3="soc-err"]'),
          socCh   = form.querySelectorAll('[data-p3="soc-ch"]'),
          socRows = form.querySelectorAll('[data-p3="soc-row"]');

      function socPicked() {
        if (socNone && socNone.checked) return true;
        for (var i = 0; i < socCh.length; i++) if (socCh[i].checked) return true;
        return false;
      }
      function socClear() {
        if (socErr) socErr.hidden = true;
        if (socBox) socBox.classList.remove('bad');
      }
      function socPaint() {
        var off = !!(socNone && socNone.checked);
        Array.prototype.forEach.call(socRows, function (r) { r.classList.toggle('off', off); });
        Array.prototype.forEach.call(socCh, function (c) { if (off) c.checked = false; c.disabled = off; });
        Array.prototype.forEach.call(form.querySelectorAll('.socr__in input'), function (t) {
          if (off) t.value = '';
          t.disabled = off;
        });
        if (socPicked()) socClear();
      }
      if (socNone) socNone.addEventListener('change', socPaint);
      Array.prototype.forEach.call(socCh, function (c) {
        c.addEventListener('change', function () {
          if (c.checked && socNone && socNone.checked) { socNone.checked = false; socPaint(); }
          if (socPicked()) socClear();
        });
      });
      if (socBox) socPaint();

      /* ── stepped flow: one question group at a time, ring shows progress ──
         Conditional steps: data-tf-if="contact[Name]^Prefix" shows a step only
         when that radio group's checked value starts with Prefix ("=" for an
         exact match). Skipped steps drop out of the count, so someone who
         declines materials sees "of 9" and never lands on the address step.
         Inside a step, Enter moves to the next field before it moves on, so an
         optional field below the fold is never jumped over; picking a radio
         that reveals a follow-up brings that follow-up into view. */
      var tf = form.querySelector('[data-p5-tf]');
      if (tf) {
        var steps = [].slice.call(tf.querySelectorAll('[data-tf-step]'));
        var ring = tf.querySelector('[data-tf-ring]'), pct = tf.querySelector('[data-tf-pct]'),
            cur = tf.querySelector('[data-tf-cur]'), tot = tf.querySelector('[data-tf-tot]'),
            back = tf.querySelector('[data-tf-back]'), next = tf.querySelector('[data-tf-next]'),
            sub = tf.querySelector('.tf__submit');
        var at = 0, C = 125.66, fxHost = tf.closest('.pick2__p');
        function stepOn(s) {
          var c = s.getAttribute('data-tf-if'); if (!c) return true;
          var m = /^(.+?)([=^])(.*)$/.exec(c); if (!m) return true;
          /* unanswered counts as shown, so the total only ever shrinks ("of 10" -> "of 9"), never grows */
          var r = form.querySelector('input[name="' + m[1] + '"]:checked'); if (!r) return true;
          return m[2] === '=' ? r.value === m[3] : r.value.indexOf(m[3]) === 0;
        }
        function live() { return steps.filter(stepOn); }
        function lastOn() { var l = live(); return steps.indexOf(l[l.length - 1]); }
        function hop(d) { for (var i = at + d; i >= 0 && i < steps.length; i += d) if (stepOn(steps[i])) return i; return at; }
        function fields(s) {
          return [].slice.call(s.querySelectorAll('input, select, textarea')).filter(function (f) {
            return f.type !== 'radio' && f.type !== 'checkbox' && f.type !== 'hidden' && !f.disabled &&
              !f.closest('[hidden]') && f.getAttribute('data-p3') !== 'hp';
          });
        }
        function reveal(el) { try { el.scrollIntoView({ block: 'center', behavior: soft }); } catch (x) { el.scrollIntoView(); } }
        function paint(dir) {
          steps.forEach(function (s, i) { s.hidden = i !== at; });
          var l = live(), pos = Math.max(0, l.indexOf(steps[at])), n = l.length;
          if (cur) cur.textContent = pos + 1;
          if (tot) tot.textContent = n;
          var p = pos / n;
          if (ring) ring.style.strokeDashoffset = (C * (1 - p)).toFixed(2);
          if (pct) pct.textContent = Math.round(p * 100) + '%';
          if (back) back.hidden = pos === 0;
          var last = at === lastOn();
          if (next) next.hidden = last;
          if (sub) sub.hidden = !last;
          tf.dispatchEvent(new CustomEvent('p5:step', { bubbles: true, detail: { at: at, pos: pos, total: n } }));
          var fxOn = !!(fxHost && fxHost.classList.contains('is-fx'));
          if (fxOn) { if (dir) fxHost.scrollTo({ top: 0, behavior: soft }); }
          else {
            var top = tf.getBoundingClientRect().top + scrollY - 96;
            if (dir && (tf.getBoundingClientRect().top < 0 || tf.getBoundingClientRect().top > innerHeight * .55)) scrollTo({ top: top, behavior: soft });
          }
          var f = steps[at].querySelector('input:not([type=radio]):not([type=checkbox]):not([hidden]), select, textarea');
          if (dir && f && (fxOn || innerWidth > 760)) f.focus({ preventScroll: true });
        }
        function valid() {
          var els = [].slice.call(steps[at].querySelectorAll('input, select, textarea'));
          for (var i = 0; i < els.length; i++) {
            var el = els[i];
            if (el.closest('[hidden]') || el.disabled) continue;
            if (!el.checkValidity()) { el.reportValidity(); return false; }
          }
          return true;
        }
        if (next) next.addEventListener('click', function () { if (!valid()) return; at = hop(1); paint(1); });
        if (back) back.addEventListener('click', function () { at = hop(-1); paint(-1); });
        form.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'BUTTON') return;
          var fs = fields(steps[at]), k = fs.indexOf(e.target);
          if (k > -1 && fs[k + 1]) { e.preventDefault(); fs[k + 1].focus({ preventScroll: true }); reveal(fs[k + 1]); return; }
          if (at !== lastOn()) { e.preventDefault(); next.click(); }
        });
        tf.addEventListener('change', function (e) {
          if (e.target.type !== 'radio') return;
          /* a radio that a later step depends on changes the total right away */
          var nm = e.target.name;
          if (steps.some(function (s) { return (s.getAttribute('data-tf-if') || '').indexOf(nm) === 0; })) paint(0);
          if (!e.isTrusted) return;
          var t = e.target;
          setTimeout(function () {
            var f = fields(steps[at]).filter(function (x) { return !x.value && (t.compareDocumentPosition(x) & 4); })[0];
            if (f) { f.focus({ preventScroll: true }); reveal(f); }
          }, 30);
        });
        /* however a field gets focus — tap, the iPhone keyboard's arrows, a
           validation error — if it sits under the pinned title bar or the pinned
           Back/Continue row, bring it clear */
        form.addEventListener('focusin', function (e) {
          var t = e.target;
          if (!fxHost || !fxHost.classList.contains('is-fx') || t.type === 'radio' || t.type === 'checkbox' || t.tagName === 'BUTTON') return;
          setTimeout(function () {
            var nb = tf.querySelector('.tf__nav'), hb = fxHost.querySelector('.fx__bar');
            if (!nb || !document.contains(t)) return;
            var r = t.getBoundingClientRect(), n = nb.getBoundingClientRect(), h = hb ? hb.getBoundingClientRect().bottom : 0;
            if (r.bottom > n.top - 8 || r.top < h + 8) reveal(t);
          }, 60);
        });
        form.addEventListener('submit', function (e) {
          for (var i = 0; i < steps.length; i++) { if (!stepOn(steps[i])) continue; at = i; if (!valid()) { e.preventDefault(); paint(1); return; } }
          if (ring) ring.style.strokeDashoffset = 0; if (pct) pct.textContent = '100%';
        }, true);
        tf.addEventListener('p5:goto', function (e) {
          at = Math.max(0, Math.min(e.detail | 0, steps.length - 1));
          while (at > 0 && !stepOn(steps[at])) at--;
          paint(0);
        });
        paint(0);
      }

      /* ── shipping: only for applicants who want materials ──
         Required while "Yes" is picked; disabled otherwise, so a declined
         applicant's half-typed address is never submitted or summarised.
         The practice name carries over from step 2 as the ship-to line. */
      var ship = [].slice.call(form.querySelectorAll('[data-p5-ship],[data-p5-ship-opt]'));
      if (ship.length) {
        var shipTo = form.querySelector('#p5-ship-to'), practice = form.querySelector('#p5-practice');
        var shipPaint = function () {
          var r = form.querySelector('input[name="contact[Materials]"]:checked');
          var on = !!(r && r.value.indexOf('Yes') === 0);
          ship.forEach(function (f) { f.disabled = !on; f.required = on && f.hasAttribute('data-p5-ship'); });
          if (on && shipTo && practice && !shipTo.value) shipTo.value = practice.value;
        };
        form.addEventListener('change', function (e) { if (e.target.name === 'contact[Materials]') shipPaint(); });
        shipPaint();
      }

      form.addEventListener('submit', function (ev) {
        var hp = form.querySelector('[data-p3="hp"]');
        if (hp && hp.value) { ev.preventDefault(); return; }
        if (socBox && !socPicked()) {
          ev.preventDefault();
          if (socErr) socErr.hidden = false;
          socBox.classList.add('bad');
          scrollTo({ top: socBox.getBoundingClientRect().top + scrollY - 90, behavior: soft });
          var f = socCh[0] || socNone;
          if (f) f.focus({ preventScroll: true });
          return;
        }
        var out = [];
        Array.prototype.forEach.call(form.elements, function (i) {
          var n = i.name || '';
          if (n.indexOf('contact[') !== 0) return;
          var k = n.slice(8, -1);
          if (k === 'body' || k === 'Leave blank' || k === 'Source' || k === 'Submitted from') return;
          if (i.disabled) return;
          if (i.type === 'radio' && i.checked) { out.push(k + ': ' + i.value); return; }
          if (i.type === 'checkbox' || i.type === 'radio' || !i.value) return;
          out.push(k + ': ' + i.value);
        });
        Array.prototype.forEach.call(form.querySelectorAll('input[type=checkbox][data-q]'), function (c) {
          out.push(c.getAttribute('data-q') + ': ' + (c.checked ? 'Yes' : 'No'));
        });
        var sm = form.querySelector('[data-p3="summary"]');
        if (sm) sm.value = 'POWCHEE Practitioners Program \u2014 application\n\n' + out.join('\n');
      }, true);
    }

    /* ── one submission per tap ──
       Shopify's spam protection intercepts every submit, runs an invisible
       hCaptcha check (1-3 s) and then sends with the native form.submit().
       Its own repeat guard clears after 250 ms, so a second tap while the
       check runs started a second check — and a second email. Its listener
       also sends regardless of whether our own checks (honeypot, social
       channel) already rejected the submission.

       This runs in the capture phase, after our validation and before
       Shopify's listener, whatever order the scripts loaded in:
         · rejected by our checks -> Shopify never sees it
         · first valid submit     -> allowed; button shows "Sending…"
         · any further submit     -> ignored
       Shopify's eventual send is a native submit, which fires no submit
       event, so this cannot block it. If the captcha is dismissed and nothing
       is sent, the button comes back after 15 s. */
    [].forEach.call(root.querySelectorAll('form[action*="/contact"]'), function (f) {
      var busy = false, btn = f.querySelector('[type=submit]'), label = btn ? btn.innerHTML : '', tmr;
      var reset = function () {
        busy = false; clearTimeout(tmr);
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; }
      };
      f.addEventListener('submit', function (e) {
        if (e.defaultPrevented) { e.stopImmediatePropagation(); return; }
        var hp = f.querySelector('[data-p3="hp"]');
        if (busy || (hp && hp.value)) { e.preventDefault(); e.stopImmediatePropagation(); return; }
        busy = true;
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.innerHTML = 'Sending&hellip;'; }
        tmr = setTimeout(reset, 15000);
      }, true);
      addEventListener('pageshow', function (ev) { if (ev.persisted) reset(); });
    });

    var ok = root.querySelector('[data-p3="ok"]');
    if (ok && !ok.hidden) scrollTo({ top: ok.getBoundingClientRect().top + scrollY - 90, behavior: soft });
  }

  /* ── two-path chooser: one panel at a time ── */
  function initPaths(root) {
    var tabs = [].slice.call(root.querySelectorAll('[data-p5-path]'));
    if (!tabs.length) return;
    var form = document.querySelector('.p3-appform');
    function pick(key, focusForm) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-p5-path') === key;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (form) {
        var r = form.querySelector('input[name="contact[Path]"][value^="' + key.toUpperCase() + ' "]');
        if (r && focusForm) r.checked = true;
      }
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { pick(t.getAttribute('data-p5-path'), true); });
    });
    pick('a', false);
  }

  function initHeard() {
    document.querySelectorAll('[data-p5-heard]').forEach(function (sel) {
      if (sel.dataset.p5HeardReady) return;
      sel.dataset.p5HeardReady = '1';
      var box = sel.parentNode.querySelector('[data-p5-heard-other]');
      if (!box) return;
      var inp = box.querySelector('input');
      function sync() {
        var on = sel.value === 'Other';
        box.hidden = !on;
        if (inp) { inp.required = on; if (on) inp.focus(); else inp.value = ''; }
      }
      sel.addEventListener('change', sync);
    });
  }

  function initLipo() {
    var d = document.getElementById('p5lipowhat');
    if (!d || d.dataset.p5Lipo) return;
    d.dataset.p5Lipo = '1';
    var mq = window.matchMedia('(min-width:861px)');
    function sync() { d.open = mq.matches; }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
    var s = d.querySelector('summary');
    if (s) s.addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); });
  }

  function boot() {
    document.querySelectorAll('[data-p5-section]').forEach(init);
    document.querySelectorAll('[data-p5="paths"]').forEach(initPaths);
    initLipo();
    initHeard();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
